import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import axios from "axios";
import {
  AuthLoginAzure,
  AuthLoginAzureV2,
  testConnectionWhenInSecondPlan,
} from "../actions";
import b2cauth from "react-azure-adb2c";
import InfoHeader from "../containers/InfoUser";
import Menu from "../containers/Menu";
import Queue from "../containers/Queue";
import QueueSlim from "../containers/QueueSlim";
import QueueNew from "../containers/QueueNew/QueueNew";
import QueueNewV2 from "../containers/QueueNew/QueueNewV2";
import QueueSlimNew from "../containers/QueueSlimNew/QueueSlimNew";
import Crm from "../containers/Crm";
import Details from "../containers/Details";
import Attendance from "../containers/Attendance";
import History from "./HistoryCalls";
import Manager from "./Manager";
import Monitorias from "./Monitorias";
import AttendanceClear from "../containers/Attendance_clear";
import ChatInternalClear from "../containers/ChatInternal_clear";
import MonitoringClear from "../containers/MonitoringClear";
import ChatInternal from "../containers/ChatInternal";
import Groups from "../containers/Groups";
import GroupsSlim from "../containers/GroupsSlim";
import { Redirect } from "react-router-dom";
import Notifications from "../containers/Notifications";
import Groupsatd from "../containers/Groupsatd";
import InternalManager from "../containers/InternalManager";
import ToastCalling from "../containers/ToastCalling";
import ErrorMessage from "../containers/ErrorMessage";
import ScreenBlock from "../containers/ScreenBlock";
import decodeJWT from "jwt-decode";
import CaptureCallModal from "../modals/CaptureCallModal";
import TimePauseModal from "../modals/TimePauseModal";
import IngDesk from "../containers/IngDesk";
import Ticket from "../containers/Ticket";
import Reservation from "../containers/Reservation";
import Email from "../containers/Email";
import ManagerNew from "./ManagerNew";
//import MountTabulator from '../containers/MountTabulator';
import NpsPage from "./NpsPage/NpsPage";
import PlatformNps from "./PlatformNps";
import DetailsAttendanceNps from "../containers/DetailsAttendanceNps/DetailsAttendanceNps";
import { Campaigns } from "../containers/Campaigns";
import QualityAgent from "./QualityAgent/QualityAgent";
import SideContentAttendance from "./SideContentAttendance";
import DetailsV2 from "../containers/DetailsV2";
import DetailsAttendanceNpsV2 from "../containers/DetailsAttendanceNpsV2/DetailsAttendanceNpsV2";
import { sideContentAttendanceSelected } from "../actions/sideContentAttendanceSelected";
import CampaignSideContent from "./CampaignSideContent/CampaignSideContent";
import HelpSideContent from "./HelpSideContent/HelpSideContent";
import NewSideMenu from "../containers/NewSideMenu/NewSideMenu";
import InternalManagerV2 from "../containers/InternalManagerV2/InternalManagerV2";
import MonitoriasV2 from "../containers/MonitoriasV2";
import ManagerPerfomance from "../containers/ManagerPerfomance";
import FaqDragableAndResizer from "../containers/FaqDragableAndResizer";
import ClientsWallet from "../containers/ClientsWallet";
import HistoryCalls from "./HistoryCallsV2/HistoryCalls";

var styles = "";
let stylesCanvas = {};

const { connection_platform } = require("../services/api");

var gethostname = window.location.hostname;
var pathname = "";

const iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;
var portims = connection_platform.port_socket_intern;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname != connection_platform.ip_intern) {
  ipcurrent =
    connection_platform.ip_extern +
    ":" +
    connection_platform.port_apache_view_extern;
  port = connection_platform.port_backend_extern;
  portims = connection_platform.port_socket_extern;
}

var idtoken = localStorage.getItem("msal.idtoken");
var decoded = [];
var username = "";

if (idtoken) {
  decoded = decodeJWT(idtoken);
  username = decoded.preferred_username;
}

const mapDispatchToProps = (dispatch) => {
  return {
    onAddPost: (post) => {
      dispatch(AuthLoginAzureV2(post));
    },
    SideContentAttendanceSelectedAction: (selected) => {
      dispatch(sideContentAttendanceSelected(selected));
    },
  };
};

const mapStateToProps = (state) => {
  return {
    VerificarUser: state.informationusers,
    InfoDisplay: state.infodisplay,
    StatusAgent: state.status,
    Atendimento: state.atendimento,
    ChatSimult: state.chatsimult,
    InfoUsers: state.informationusers,
    MonitoringSimult: state.monitoringsimult,
    IsSideContentOpen: state.isSideContentOpen,
    SideContentAttendanceSelected: state.sideContentAttendanceSelected,
    IsOpenFaqDragable: state.isOpenFaqDragableReducer,
  };
};

class Azure extends React.Component {
  componentDidMount() {
    if (username === "")
      window.open(
        `${connection_platform.type_connect}://${window.location.hostname}:${connection_platform.port_node}`,
        "_self",
      );
    this.props.onAddPost(username);

    let interval = null;

    const handleVisibilityChange = () => {
      const isInSecondPlan = document.hidden;
      if (isInSecondPlan) {
        interval = setInterval(() => {
          testConnectionWhenInSecondPlan();
        }, 120000);
      } else {
        const hasInterval = !!interval;
        if (hasInterval) {
          clearInterval(interval);
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);

      const hasInterval = !!interval;
      if (hasInterval) {
        clearInterval(interval);
      }
    };
  }

  renderSideContent(contentSelected, hasPesquisa = true) {
    if (contentSelected === "pesquisa" && !hasPesquisa) {
      this.props.SideContentAttendanceSelectedAction("detalhes");
      return <DetailsV2 displayscreen={"atendance"} />;
    }
    switch (contentSelected) {
      case "detalhes":
        return <DetailsV2 displayscreen={"atendance"} />;
      case "pesquisa":
        return <>pesquisa</>;
      case "campanhas":
        return <CampaignSideContent />;
      case "ajuda":
        return <HelpSideContent />;
      default:
        return <DetailsV2 displayscreen={"atendance"} />;
    }
  }

  renderSideContentNpsAndCallCenter(contentSelected, hasPesquisa = true) {
    switch (contentSelected) {
      case "detalhes":
        return <DetailsV2 displayscreen={"atendance"} />;
      case "pesquisa":
        return <DetailsAttendanceNpsV2 />;
      case "campanhas":
        return <CampaignSideContent />;
      case "ajuda":
        return <HelpSideContent />;
      default:
        return <DetailsV2 displayscreen={"atendance"} />;
    }
  }

  render() {
    var collumm2 = <AttendanceClear />;
    var collumm3 = "";
    var collumm4 = <QueueSlimNew />;
    // var collumm5 = <QueueNew />;
    var collumm5 = <QueueNewV2 />;
    var collumm6 = "";
    var collumm7 = <Notifications />;
    var collumm8 = <GroupsSlim />;
    var collumm9 = <Groups />;
    //var collumm10 = <ToastCalling/>;
    var collumm10 = "";
    var collumm11 = <ErrorMessage />;
    // var collumm12  = <AlertQueue />;
    var collumm13 = <ScreenBlock />;
    var collumm14 = <CaptureCallModal />;
    var collumm15 = <TimePauseModal />;
    //var collumm18 = <MountTabulator />;

    const {
      VerificarUser,
      InfoDisplay,
      Atendimento,
      ChatSimult,
      InfoUsers,
      MonitoringSimult,
      IsSideContentOpen,
      SideContentAttendanceSelected,
    } = this.props;

    if (InfoDisplay.infodisplay === "Monitorias") {
      document.getElementsByTagName("BODY")[0].classList.add("page-monitoria");
    } else {
      document
        .getElementsByTagName("BODY")[0]
        .classList.remove("page-monitoria");
    }

    // if (VerificarUser.length === 0)
    //     return <Redirect to='/login' />;

    if (Atendimento.length != 0) {
      collumm2 = <Attendance />;

      const isFromNps = Atendimento.nps_call;

      if (isFromNps && IsSideContentOpen) {
        collumm3 = (
          <SideContentAttendance hasPesquisa={true}>
            {this.renderSideContentNpsAndCallCenter(
              SideContentAttendanceSelected,
              true,
            )}
          </SideContentAttendance>
        );
      }
      if (!isFromNps && IsSideContentOpen) {
        collumm3 = (
          <SideContentAttendance hasPesquisa={false}>
            {this.renderSideContent(SideContentAttendanceSelected, false)}
          </SideContentAttendance>
        );
      }
      if (isFromNps && !IsSideContentOpen) {
        collumm3 = "";
      }
      if (!isFromNps && !IsSideContentOpen) {
        collumm3 = "";
      }

      collumm6 = <Crm />;
    } else {
      collumm3 = "";
      collumm6 = "";
    }

    if (InfoDisplay.infodisplay === "Historic") {
      // collumm2 = <History />;
      collumm2 = <HistoryCalls />;
      collumm3 = "";
      collumm4 = "";
      collumm5 = "";
      collumm6 = "";
    }

    if (InfoDisplay.infodisplay === "IngDesk") {
      collumm2 = <IngDesk />;
      collumm3 = "";
      collumm4 = "";
      collumm5 = "";
      collumm6 = "";
    }

    if (InfoDisplay.infodisplay === "Email") {
      collumm2 = <Email />;
      collumm3 = "";
      collumm4 = "";
      collumm5 = "";
      collumm6 = "";
    }

    if (InfoDisplay.infodisplay === "Casos") {
      collumm2 = <Ticket />;
      collumm3 = "";
      collumm4 = "";
      collumm5 = "";
      collumm6 = "";
    }

    if (InfoDisplay.infodisplay === "CarteiraDeClientes") {
      collumm2 = <ClientsWallet />;
      collumm3 = "";
      collumm4 = "";
      collumm5 = "";
      collumm6 = "";
    }

    if (InfoDisplay.infodisplay === "Reservas") {
      collumm2 = <Reservation />;
      collumm3 = "";
      collumm4 = "";
      collumm5 = "";
      collumm6 = "";
    }

    if (InfoDisplay.infodisplay === "Gestor") {
      // collumm4 = <QueueSlim/>;
      // collumm5 = <Queue/>;
      // collumm6 = <GroupsSlim/>;
      // collumm2 = <Groups screen={'Gestor'}/>;
      // collumm3 = <Manager/>
      collumm4 = <QueueSlim />;
      collumm5 = <Queue />;
      collumm6 = "";
      collumm2 = "";
      collumm3 = <Manager />;
    }

    if (InfoDisplay.infodisplay === "Gestor2") {
      collumm2 = <ManagerNew />;
      collumm3 = "";
      collumm4 = "";
      collumm5 = "";
      collumm6 = "";
    }

    if (InfoDisplay.infodisplay === "NPS") {
      collumm2 = <NpsPage />;
      collumm3 = "";
      collumm4 = "";
      collumm5 = "";
      collumm6 = "";
    }

    if (InfoDisplay.infodisplay === "QualityAgent") {
      collumm2 = <QualityAgent />;
      collumm3 = "";
      collumm4 = "";
      collumm5 = "";
      collumm6 = "";
    }

    if (InfoDisplay.infodisplay === "Equipes") {
      // collumm4 = <InternalManager/>
      // collumm6 = '';
      // collumm5 = '';
      // collumm3 = '';
      // collumm2 = '';

      collumm4 = <QueueSlimNew />;
      // collumm5 = <QueueNew />;
      collumm5 = <QueueNewV2 />;
      collumm6 = <InternalManagerV2 />;
      collumm3 = InfoUsers.supervisor === true ? <ManagerPerfomance /> : "";
      collumm2 = "";
    }

    if (InfoDisplay.infodisplay === "Atendentes") {
      if (ChatSimult.length != 0) {
        collumm2 = <ChatInternal />;
      } else {
        collumm2 = <ChatInternalClear />;
      }
      collumm3 = "";
      collumm5 = "";
      collumm6 = <Groupsatd />;
      collumm4 = "";
    }

    if (InfoDisplay.infodisplay === "Arquivos") {
      collumm2 = "";
      collumm3 = "";
      collumm5 = "";
      collumm6 = "";
      collumm4 = "";
    }

    if (InfoDisplay.infodisplay === "Monitorias") {
      if (MonitoringSimult.length != 0) {
        collumm3 = <MonitoriasV2 />;
      } else {
        collumm3 = <MonitoringClear />;
      }
      collumm4 = "";
      collumm5 = "";
      //collumm6 = <GroupsSlim />;
      //collumm2 = <Groups screen={"Monitorias"} />;
      collumm6 = "";
      collumm2 = "";
    }

    if (InfoDisplay.infodisplay === "PlatformNps") {
      collumm2 = "";
      collumm3 = "";
      collumm5 = "";
      collumm6 = "";
      collumm4 = <PlatformNps />;
    }

    if (InfoDisplay.infodisplay === "Campanhas") {
      collumm2 = "";
      collumm3 = "";
      collumm5 = "";
      collumm6 = "";
      collumm4 = <Campaigns />;
    }

    if (InfoUsers.email === null) {
      styles = {
        filter: "blur(4px)",
        userselect: "none",
        height: "100dvh",
        overflow: "hidden",
      };
    } else {
      styles = {};
    }

    if (
      InfoDisplay.infodisplay === "Equipes" ||
      InfoDisplay.infodisplay === "Clientes"
    ) {
      stylesCanvas = {
        padding: "10px 10px 0",
      };
    } else {
      stylesCanvas = {};
    }

    return (
      <React.Fragment>
        <InfoHeader />
        <div className="stage" style={styles}>
          <div id="drawer-portal-root"></div>
          <NewSideMenu />
          <div className="canvas" style={stylesCanvas}>
            {collumm4}
            {collumm5}
            {collumm6}
            {collumm2}
            {collumm3}
            {collumm7}
            {collumm10}
            {collumm11}
            {collumm14}
            {collumm15}
            {/* {collumm18} */}
          </div>
          {Boolean(this.props.IsOpenFaqDragable) &&
            this.props.IsOpenFaqDragable.isOpen && <FaqDragableAndResizer />}
        </div>
        {collumm13}
        <div
          className={
            VerificarUser.email === null
              ? "modal-overlay modal__pausa-errada active"
              : "modal-overlay modal__pausa-errada"
          }
        >
          <div className="modal-box">
            <div className="modal-box__header">
              <p className="modal-box__title">INATIVO</p>
              {/* <span className="modal-box__close-btn btn-close__logout"><i className="material-icons modal-box__close-icon">close</i></span> */}
            </div>
            <div className="modal-box__content">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTfQiQbbOcOXy7XEGHKRqZZzjyvmcPGL3sWPQ&usqp=CAU"
                alt=""
                className="modal-box__img"
              />
              <h3 className="modal-box__warning is-poppins pd-0">
                Usuário não cadastrado.
                <em className="is-poppins is-poppins--bold"></em>
              </h3>
              <p className="modal-box__message"></p>
              <a
                href="/login"
                style={{ display: "none" }}
                id="logoutclicado"
                className="logout btn btn-outline"
              >
                SAIR
              </a>
              {/* <p className="modal-box__message">
                              Solicite ao seu gestor para efetue o desbloqueio de seu login
                            </p> */}
              <br />
              <p className="modal-box__message">
                Contacte o administrador do sistema para maiores informações.
              </p>
              <a className="modal-box__return-btn btn-return__pausa-errada">
                Sair
              </a>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Azure);
